let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1SWXL")).then(() => parcelRequire('4X7S2'));